import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import '../Item/Item.css';

const TableNameCreate = () => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [name, setName] = useState('');
    const [isParcel, setIsParcel] = useState(false);
    const [isGst, setIsGst] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, token]);

    const submitData = (e) => {
        e.preventDefault();
        if (!name) { setErrorMessage('Table Name is required!'); return; }
        postData('TableNameApi', { Name: name, IsParcel: isParcel, GstNotApplicable: isGst, CreatedBy: userId, CompanyId: companyId, CreatedDate: new Date() }, token)
            .then(() => {
                setSuccessMessage('Table Name created successfully!');
                setErrorMessage('');
                history.push('/TableNameIndex');
            })
            .catch((e) => { console.error('Table Name Create error:', e); setErrorMessage('Error creating table name.'); });
    };

    return (
        <div className="item-container">
            <div className="item-header-card">
                <div className="item-header-content">
                    <div className="item-title-section">
                        <span className="item-title-icon"><TableRestaurantIcon fontSize="small" /></span>
                        <h1 className="item-title">Table Name Create</h1>
                    </div>
                    <div className="item-header-actions">
                        <button className="it-btn it-btn-save" onClick={submitData}>
                            <SaveIcon style={{ fontSize: 14 }} />&nbsp;Save
                        </button>
                        <Link to="/TableNameIndex" className="it-btn it-btn-back">
                            <ArrowBackIcon style={{ fontSize: 14 }} />&nbsp;Back
                        </Link>
                    </div>
                </div>
            </div>

            {errorMessage && <div className="item-alert item-alert-error">{errorMessage}</div>}
            {successMessage && <div className="item-alert item-alert-success">{successMessage}</div>}

            <div className="item-form-card">
                <p className="item-form-section-title">Table Information</p>
                <div className="item-form-row">
                    <div className="item-form-group w-3">
                        <label className="item-label">Table Name <span className="required">*</span></label>
                        <input className="item-input" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter table name" required maxLength={20} />
                    </div>
                    <div className="item-form-group">
                        <label className="item-label">Include Parcel Charge?</label>
                        <div className="item-checkbox-group">
                            <input className="item-checkbox" type="checkbox" id="isParcel" checked={isParcel} onChange={(e) => setIsParcel(e.target.checked)} />
                            <label className="item-checkbox-label" htmlFor="isParcel">Yes</label>
                        </div>
                    </div>
                    <div className="item-form-group">
                        <label className="item-label">GST Not Applicable?</label>
                        <div className="item-checkbox-group">
                            <input className="item-checkbox" type="checkbox" id="isGst" checked={isGst} onChange={(e) => setIsGst(e.target.checked)} />
                            <label className="item-checkbox-label" htmlFor="isGst">Yes</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableNameCreate;
